import { Box, FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import { ILeftInnerNav, ILeftInnerNavPath, settingsArray } from '../../shared/data/navigation.data'
import { useNavigate } from 'react-router-dom'
import { useContext, useEffect, useState } from 'react'
import { UserDetailsContext } from '../../context/user-details/user-details'
import { IRoleType } from '../../shared/services/user-details/user-details.model'
import { userHasRequiredRole as hasRequiredRole } from '../../shared/utils/role-utils';

export const SettingsMobileNavbar = () => {

  const navigate = useNavigate();
  const userDetailsContext = useContext(UserDetailsContext)
  const userDetails = userDetailsContext.userDetails
  const [selectedPage, setSelectedPage] = useState<string>('/settings/personal-settings/your-profile')

  useEffect(() => {
    setSelectedPage(window.location.pathname)
  }, [window.location.pathname])

  function userHasRequiredRole(allowedRoles: IRoleType[]): boolean {
    return hasRequiredRole(userDetails, allowedRoles)
  }

  const handleClick = (settingPath: string) => {
    navigate(settingPath)
  }

  return (
    <Box>
      {settingsArray &&
        <FormControl fullWidth>
          <InputLabel htmlFor="selectedPage">Settings Page</InputLabel>
          <Select value={selectedPage || ''} id="selectedPage" label="Settings Page"
          >
            {settingsArray.map((object: ILeftInnerNav, index: number) => {
              return userHasRequiredRole(object.allowedRoles) &&
                object.subcategory
                  .filter((setting) => setting.to !== '/settings/company-settings/api-keys' || (userDetails?.organisation?.allowApiAccess ?? false))
                  .map((setting: ILeftInnerNavPath) => {
                    return <MenuItem key={setting.name} value={setting.to} sx={{ color: 'text.primary' }} onClick={() => handleClick(setting.to)}>{setting.name}</MenuItem>
                  })
            })}
          </Select>
        </FormControl >
      }
    </Box>
  )
}